import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { FilterCardTitle, FilterCardTitleWrapper } from './styled';

const CardTitle = ({ onVisibleChange }) => (
  <FilterCardTitleWrapper>
    <FilterCardTitle>Filter</FilterCardTitle>
    <Button onClick={onVisibleChange}>
      <i className="fa fa-times"></i>
    </Button>
  </FilterCardTitleWrapper>
);

CardTitle.propTypes = {
  onVisibleChange: PropTypes.func
};

export default CardTitle;
